import { render } from "./RetributionConfigurations.vue?vue&type=template&id=c6e8d6be"
import script from "./RetributionConfigurations.vue?vue&type=script&lang=js"
export * from "./RetributionConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__